<template>
  <div id="wrapper">
    <Nav :message="message" />
    <BlogForm />
  </div>
</template>
<script>
// @ is an alias to /src
import Nav from '@/components/Nav.vue'
import BlogForm from '@/components/website/BlogForm.vue'

export default {
  name: 'createBlog',
  props: ['message'],
  components: {
    Nav,
    BlogForm
  }
}
</script>